import { apiFetch } from './client';

export const fetchOperationsOverview = async () => apiFetch('/api/ops/overview');

export const saveReportSchedule = async (payload) =>
  apiFetch('/api/ops/report-schedules', {
    method: 'POST',
    body: payload,
  });

export const createReportSnapshot = async (payload) =>
  apiFetch('/api/ops/report-snapshots', {
    method: 'POST',
    body: payload,
  });

export const fetchReportSnapshot = async (slug) => apiFetch(`/api/ops/report-snapshots/${encodeURIComponent(slug)}`);

export const fetchSavedReports = async () => apiFetch('/api/ops/saved-reports');

export const saveBuiltReport = async (payload) =>
  apiFetch('/api/ops/saved-reports', {
    method: 'POST',
    body: payload,
  });

export const exportCustomerReport = async (payload) =>
  apiFetch('/api/ops/report-export', {
    method: 'POST',
    body: payload,
  });

export const requestCommercialUpgrade = async (payload) =>
  apiFetch('/api/ops/upgrade-request', {
    method: 'POST',
    body: payload,
  });
